import React from "react";
import { Button } from "antd-mobile";
import defaultImg from "./default.jpg";

class noSorrow extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  render() {
    return (
      <div
        className="noSorrowBox"
        style={{ minHeight: "100vh", background: "#f3f4f5" }}
      >
        <img src={defaultImg} style={{ width: "100%" }} />
      </div>
    );
  }
}
export default noSorrow;



// WEBPACK FOOTER //
// ./src/noSorrow/index/index.js